// extracted by mini-css-extract-plugin
export default {"rating":"kC-z","numberOfStars":"lC-z","count":"mC-z","barGraphSpacing":"nC-z","barGraph":"oC-z"};